import { useRouteError } from 'react-router-dom';

export function ErrorBoundaryComponent() {
    const error = useRouteError() as Error;

    return (
        <div
            style={{
                borderStyle: 'solid',
                borderWidth: '2px',
                borderColor: '#ff8080',
                backgroundColor: '#ffc3c3',
                padding: 10,
                borderRadius: 5,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                <div>
                    <div>
                        <b>Don't worry... but it seems the machines have risen.</b>
                    </div>
                    <div>
                        <b>They say:</b>
                    </div>
                    <div style={{ fontStyle: 'italic', margin: '10px 0' }}>{error.message}</div>
                    <div>
                        <b>We’re on it. Humanity still has a chance.</b>
                    </div>
                </div>
            </div>
        </div>
    );
}
